/* lua.js generated code 0.3.1 */

require("clover/gamePlay/CreateGameSceneLogic")
let StartPvpLevelLogic = xClass("StartPvpLevelLogic")
StartPvpLevelLogic.checkCanStart = function (levelId) {
    return [true]
}
StartPvpLevelLogic.create = function (levelId, isFriendPvp = false) {
    let self = this
    let [success, errCode] = self.checkCanStart(levelId)
    if (!success) {
        return [null, errCode]
    }
    return [StartPvpLevelLogic.new(levelId, isFriendPvp)]
}
StartPvpLevelLogic.prototype.ctor = function (levelId, isFriendPvp) {
    let self = this
    self.levelId = levelId
    self.initProps = table()
    self.isBusy = false
    self.waitingPanelAnim = false
    self.successCallback = null
    self.failCallback = null
    self.isFriendPvp = isFriendPvp;
}
StartPvpLevelLogic.prototype.initLevelLogics = function () {
    var self = this;
    if (self.isFriendPvp){
        require.ensure([], () => {
            require("clover/scene/GameScene")
            require("clover/scene/GameSceneUI")
            FailLevelLogicClassTypeRef[GameLevelType.kPvp] = require("activity/PvpActivity/startEndLevelLogic/WinFriendPvpLevelLogic")
            PassLevelLogicClassTypeRef[GameLevelType.kPvp] = require("activity/PvpActivity/startEndLevelLogic/WinFriendPvpLevelLogic")
            QuitLevelLogicClassTypeRef[GameLevelType.kPvp] = require("activity/PvpActivity/startEndLevelLogic/QuitFriendPvpLevelLogic")
        }, null, 'game')
    }else{
        // 旧pvp全部废弃，只支持友谊赛了
        throw new Error("pvp is obsoleted!");
    }
}
StartPvpLevelLogic.prototype.start = function (pvpLevelInfo) {
    let self = this
    // self.initLevelLogics()
    UserLevel.getInstance().addLevelTypeEnum(GameLevelType.kPvp, require("activity/PvpActivity/startEndLevelLogic/UserLevelTypePvp"))
    self.startLevel(pvpLevelInfo)
}
StartPvpLevelLogic.prototype.levelInfo = function () {
    let self = this
    let ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
    let levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    ret.levelType = levelType
    ret.levelId = self.levelId
    return ret
}
StartPvpLevelLogic.prototype.startLevelReplay = function(replay, id, score) {
    let self = this
    var pvpLevelInfo = {};
    pvpLevelInfo.randomSeed = replay.randomSeed;
    pvpLevelInfo.levelId = replay.levelId;
    pvpLevelInfo.isFriendPvp = self.isFriendPvp;
    if (self.isFriendPvp){
        UserLevel.getInstance().addLevelTypeEnum(GameLevelType.kPvp, require("activity/PvpActivity/startEndLevelLogic/UserLevelTypePvp"))
    }
    var logic = CreateGameSceneLogic.create(self.levelId, table()) //selectedItemsData
    logic.setOtherData(pvpLevelInfo)
    logic.startReplayGamePlayScene(replay, id, score, function() {
        self.initLevelLogics()
    })
}
StartPvpLevelLogic.prototype.startLevel = function (pvpLevelInfo = {}) {
    let context = this
    pvpLevelInfo.isFriendPvp = context.isFriendPvp;
    cc.log("start pvp Level ============ ", pvpLevelInfo)
    let instance = CreateGameSceneLogic.create(context.levelId, context.initProps)
    instance.setOtherData(pvpLevelInfo)
    instance.startGamePlayScene(function (fileList) {
        function success() {
            context.initLevelLogics()
            instance.createGamePlayScene(fileList)
        }
        success()
    })
}
module.exports = StartPvpLevelLogic
